<template>
    <div class="discount-management">
    <!-- 搜尋與功能區 -->
    <div class="search-bar-top">
      <div class="search-input-container">
        <i class="fas fa-search search-icon"></i>
        <input type="text" placeholder="搜尋" v-model="searchQuery" />
      </div>
    </div>
    <div class="action-buttons">
      <button
        class="action-button"
        :class="{ active: activeButton === 'all' }"
        @click="setActiveButton('all')"
      >
        顯示所有
      </button>
      <button
        class="action-button"
        :class="{ active: activeButton === 'checkIn' }"
        @click="setActiveButton('checkIn')"
      >
        已回覆
      </button>
      <button
        class="action-button"
        :class="{ active: activeButton === 'checkOut' }"
        @click="setActiveButton('checkOut')"
      >
        未回覆
      </button>
    </div>

    <!-- 表格 -->
    <table class="member-table">
      <thead>
        <tr>
          <th>編號</th>
          <th>客戶姓名</th>
          <th>信箱</th>
          <th>手機</th>
          <th>建立日期</th>
          <th>是否回覆</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="contact in paginatedContacts" :key="contact.id">
          <td>{{ contact.id }}</td>
          <td>{{ contact.name }}</td>
          <td>{{ contact.email }}</td>
          <td>{{ contact.phone }}</td>
          <td>{{ formatDate(contact.createDate) }}</td>
          <td>{{ contact.reply ? '已回覆' : '未回覆' }}</td>
          <td>
            <button @click="editContact(contact)" class="btn btn-edit">查看</button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 查看彈窗 -->
    <div v-if="showEditModal" class="edit-modal">
      <div class="modal-content">
        <h2>查看留言</h2>
        <div class="form-group">
          <label>編號</label>
          <input v-model="editContactData.id" disabled />
        </div>
        <div class="form-group">
          <label>客戶姓名</label>
          <input v-model="editContactData.name" disabled />
        </div>
        <div class="form-group">
          <label>電子郵件</label>
          <input v-model="editContactData.email" disabled />
        </div>
        <div class="form-group">
          <label>電話號碼</label>
          <input v-model="editContactData.phone" disabled />
        </div>
        <div class="form-group">
          <label>留言內容</label>
          <textarea v-model="editContactData.message"></textarea>
        </div>
        <div class="form-group">
          <label>建立日期</label>
          <input :value="formatDate(editContactData.createDate)" disabled />
        </div>
        <div class="form-group">
          <label>回覆狀態</label>
          <select v-model="editContactData.reply">
            <option :value="true">已回覆</option>
            <option :value="false">未回覆</option>
          </select>
        </div>
        <div class="modal-actions">
          <button class="update-button" @click="saveEdit">保存</button>
          <button class="cancel-button" @click="closeEditModal">取消</button>
        </div>
      </div>
    </div>
      <!-- 分頁按鈕 -->
      <div class="pagination">
        <button class="page-btn" :disabled="!hasPreviousPage" @click="prevPage">
          « Previous
        </button>
        <button
          v-for="page in totalPages"
          :key="page"
          :class="['page-number', { active: page === currentPage }]"
          @click="goToPage(page)"
        >
          {{ page }}
        </button>
        <button class="page-btn" :disabled="!hasNextPage" @click="nextPage">
          Next »
        </button>
      </div>
    </div>
  </template>
  
  <script>
  import contactusLogic from "@/assets/js/background/contactus.js";
  
  export default {
    name: "ContactusManagement",
    mixins: [contactusLogic],
  };
  </script>
  
  <style src="@/assets/css/background/contactus.css" scoped></style>